import { Anchor } from '@zillow/constellation-10';
import Link from 'next/link';
import router from 'next/router';
import type { MouseEvent } from 'react';
import { getEditRoute } from '../../../../constants/urls';

export function EditInStepLink({
  applicationId,
  stepId,
  label,
  onPersist,
}: {
  applicationId: string;
  stepId: string;
  label: string;
  onPersist?: () => Promise<void>;
}) {
  const route = getEditRoute({ applicationId, stepId });

  async function onClick(event: MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    await onPersist?.();
    router.push(route);
  }

  return (
    <>
      Need to update? Edit in{' '}
      <Anchor asChild>
        <Link href={route} onClick={onClick}>
          {label}
        </Link>
      </Anchor>
      .
    </>
  );
}
